import Axios from "../../../../api/axios/Axios";

const BASE_URL = "/api/videos";

const encode = (value) => encodeURIComponent(String(value));

export const getVideos = async ({
  creator = "katchrugby",
  search = "",
  limit = 12,
  offset = 0,
} = {}) => {
  const response = await Axios.get(BASE_URL, {
    params: {
      creator,
      search,
      limit,
      offset,
    },
  });

  return response.data;
};

export const getVideoDetails = async (videoTag) => {
  const response = await Axios.get(`${BASE_URL}/${encode(videoTag)}`);

  return response.data;
};
